<template>
  <section class="page-container">
    <div class="header flex-sb-center mg-b-30">
      <span class="fs-24 color-dark fw-600">Create Team</span>
      <span class="flex">
        <v-button
          gray
          class="mg-r-15"
          @click="handleBack">Cancel</v-button>
        <v-button
          green
          @click="handleConfrim">Confirm</v-button>
      </span>
    </div>
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <div class="form-item w-335">
        <span>Team Name</span>
        <el-form-item
          ref="name"
          prop="name"
          :rules="rules.input">
          <v-input
            v-model="formData.name"
            uppercase
            letter-and-number
            key-non-chinese></v-input>
        </el-form-item>
      </div>
      <span class="mg-b-20 block fs-12 color-dark">The team name can consist of up to 20 letters.</span>
      <div class="form-item">
        <span>Team Head</span>
        <el-form-item
          ref="leader_id"
          prop="leader_id"
        >
          <v-button
            gray
            @click="handleSelectTeam">{{team_head_name}}</v-button>
        </el-form-item>
      </div>
    </el-form>
    <attach-customer
      ref="attachCustomer"
      :customer-type="1"
      is-all-type
      can-select-all
      is-tier-base
      is-share
      @shareUser="handleSelectCustomer"></attach-customer>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import attachCustomer from '@/views/quoting/dialogs/attachCustomer'
import {createSpecialTeam} from '@api/team'
export default {
  name: 'create-team',
  components:{
    attachCustomer
  },
  mixins: [MixinOptions,MixinRules],
  data(){
    return{
      formData:{
        name:'',
        leader_id:''
      },
      team_head_data:{}
    }
  },
  computed:{
    team_head_name(){
      let {id_type,isrd_nm} = this.team_head_data||{}
      return isrd_nm||'Select'
    }
  },
  methods:{
    handleSelectTeam(){
      this.$refs.attachCustomer.showAttachCustomer()
    },
    handleSelectCustomer(user_id,data){
      this.formData.leader_id = user_id
      this.team_head_data = data||{}
    },
    handleConfrim(){
      this.$refs['form'].validate((valid, rules) => {
        if (valid) {
          // let{leader_id} = this.formData||{}
          // if(!leader_id)
          //   delete this.formData.leader_id
          this.network().createSpecialTeam(this.formData)
        }
      })
    },
    handleBack(){
      this.$router.back()
    },
    network(){
      return{
        createSpecialTeam: async (params) => {
          const {data} = await createSpecialTeam({
            ...params,
          })
          this.$router.back()
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-container{
  margin: 30px 20px;
  .w-335{
    width: 335px;
  }
  .fs-24{
    font-size: 24px;
  }
}
</style>